import { CellProps, Column } from "@shared/primitive-components"
import { useInternalFlags } from "../hooks"

// ---------------------------------------------------------------------------------------------------------------------

type Obfuscate = Readonly<{ type?: "id" | "vrn"; value: number | string }>

export const obfuscate = ({ type, value }: Obfuscate): string => {
  switch (type) {
    case `id`:
      return value.toString().replace(/[^-]/g, `*`)
    case `vrn`:
      return value.toString().replace(/[^\s]/g, `*`)
    default:
      return value.toString().replace(/[^\s]/g, `*`)
  }
}

export const MaybeObfuscatedValue = ({ type, value }: Obfuscate): JSX.Element => {
  const { flags } = useInternalFlags()

  return flags.isDemoModeEnabled ? <>{obfuscate({ type, value })}</> : <>{value}</>
}

// ---------------------------------------------------------------------------------------------------------------------

export const buildMaybeObfuscatedHeader = <T extends Record<string, unknown>>(
  accessor: string,
  Header: string | (() => JSX.Element),
  options?: { type: Obfuscate["type"] }
): Column<T> => ({
  accessor,
  Cell: ({ value }: CellProps<string, T>) => MaybeObfuscatedValue({ type: options?.type, value }),
  Header,
})
